
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Popup, ScrollView, SelectBox } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, openItemDialog, setItemTypeId } from '../../store/item/itemDialogReducer'
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { createCustomStore, createStore } from '../../utils/proxy';
import Form, { EmptyItem, GroupItem, Item, Label, RequiredRule, SimpleItem, StringLengthRule } from 'devextreme-react/form';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import HtmlEditor, { Toolbar, MediaResizing } from 'devextreme-react/html-editor';
import { catalogosConocidos, tipoArticulos, catalogoValores } from '../../data/catalogos';
import LensItemProperties from './LensItemProperties';
import { esferas, cilindros, reChanges } from '../../utils/custom';
import { useBarcode } from 'react-barcodes';
import urlReport from '../../services/reportServices';


const defualtItem = {
  id: 0,
  name: '',
  description: '',
  productNumber: '',
  typeId: null,
  safetyStockLevel: 0,
  reorderPoint: 0,
  unitMeasure: 0,
  currency: '',
  price: 0,
  cost: 0,
  quantity: 0,
  markup: '',
  brandId: null,
  modelId: null,
  profitPercent: 0,
  code: 0,
  preview: '',
  itemTypes: [],
  lensItem: {
    type: null,
    subType: null,
    material: null,
    treatment: null,
    color: null
  },
  contactLensItem: {
    type: null,
    sphere: null,
    cylinder: null,
    radius: null,
    diameter: null,
    power: null
  },
  frameItem: {
    size: null,
    color: null,
    frameType: null,
    frameHeight: null
  },
  maintenanceItem: {
    subType: null,
    indications: null
  },
  scleralItem: {
    type: null
  },
  areaProductStock: {
    price: 0,
    costAvg: 0
  },
  catalogs: []
};

const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
const headerValues = [false, 1, 2, 3, 4, 5];

const catalogs = [catalogosConocidos.MarcaLenteOftalmico,
catalogosConocidos.ModeloLenteOftalmico,
catalogosConocidos.MarcaLenteContacto,
catalogosConocidos.ModeloLenteContacto,
catalogosConocidos.TipoLente,
catalogosConocidos.SubTipoLente,
catalogosConocidos.Material,
catalogosConocidos.Tratamiento,
catalogosConocidos.Color,
catalogosConocidos.AlturaMarco,
catalogosConocidos.TipoMarco,
catalogosConocidos.SubTipoMantenimiento,
catalogosConocidos.TipoLenteContacto,
catalogosConocidos.MarcaMarcoAro,
catalogosConocidos.ModeloMarcoAro,
catalogosConocidos.MarcaAccesorio,
catalogosConocidos.MarcaLentesEsclerales,
catalogosConocidos.ModeloLentesEsclerales,
catalogosConocidos.TipoLentesEsclerales,
]

const AddItemDialog = (props) => {

  const { updateParent } = props;
  defualtItem.typeId = props.typeId;

  let dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [item, setsItem] = useState(defualtItem);
  const { itemDialog, appInfo } = useSelector((store) => store);

  const formRef = useRef();

  const onLoad = (itemId) => {
    Promise.all([
      http(uri.itemValues(itemId)).asGet(),
      http(uri.itemTypes.get).asGet(),
      http(uri.catalogEntriesByNames).asPost(catalogs)
    ]).then(result => {
      let r = {
        ...item,
        ...result[0],
        itemTypes: result[1],
        catalogs: result[2]
      };
      if (r.areaProductStock == null)
        r.areaProductStock = { price: 0, costAvg: 0 };

      setsItem(r);
    });
  }

  const loadCatalogs = () => {

    Promise.all([
      http(uri.itemTypes.get).asGet(),
      http(uri.catalogEntriesByNames).asPost(catalogs)
    ]).then(result => {
      setsItem(prev => {
        return {
          ...prev,
          itemTypes: result[0],
          catalogs: result[1]
        }
      });

    });
  }

  useEffect(() => {

    clearItem();

  }, [appInfo]);

  useEffect(() => {

    if (itemDialog.itemId != null && itemDialog.itemId != 0) {
      //Edicion
      onLoad(itemDialog.itemId);
    } else {
      //Nuevo

      clearItem();
      //Cargar Catalogos
      loadCatalogs();
    }



  }, [itemDialog.itemId]);

  let editable = true;

  const guardarItem = (params) => {

    if (formRef.current.instance.validate().isValid) {
      var data = {
        ...item,
        itemTypeProperties: null,
        type: null,
        lensItem: item.typeId == tipoArticulos.LentesOftalmicos ? item.lensItem : null,
        contactLensItem: item.typeId == tipoArticulos.LentesDeContacto ? item.contactLensItem : null,
        frameItem: item.typeId == tipoArticulos.MarcoAro ? item.frameItem : null,
        maintenanceItem: item.typeId == tipoArticulos.Mantenimiento ? item.maintenanceItem : null,
        scleralItem: item.typeId == tipoArticulos.LentesEsclerales ? item.scleralItem : null,
      }

      setSaving(true);
      http(uri.items.insert).asPost(data).then(resp => {
        notify('Datos guardados correctamente');
        dispatch(closeDialog());
        updateParent();
        clearItem();
        setSaving(false);
      }).catch(err => {
        setSaving(false);
        notify(err, 'error');
      }
      )
    }
  }

  const clearItem = () => {

    setsItem(prev => {
      return {
        ...defualtItem,
        lensItem: { ...defualtItem.lensItem },
        contactLensItem: { ...defualtItem.contactLensItem },
        frameItem: { ...defualtItem.frameItem },
        maintenanceItem: { ...defualtItem.maintenanceItem },
        scleralItem: { ...defualtItem.scleralItem },
        areaProductStock: { ...defualtItem.areaProductStock },
        profitPercent: appInfo.profitPercent,
        catalogs: [...prev.catalogs]
      };
    })
  }



  const onBrandChanged = ({ value }) => {
    setsItem(prev => {
      return {
        ...prev,
        brandId: value,
        preview: getPreview({ ...prev, brandId: value })
      };
    });
  }

  const onModelChanged = ({ value }) => {
    setsItem(prev => {
      return {
        ...prev,
        modelId: value,
        preview: getPreview({ ...prev, modelId: value })
      };
    });
  }

  const onLensTypeChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        lensItem: {
          ...prev.lensItem,
          type: value
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const onLensTreatmentChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        lensItem: {
          ...prev.lensItem,
          treatment: value,
          color: value != catalogoValores.Tratamiento.Color ? 0 : prev.lensItem.color
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const onLensColorChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        lensItem: {
          ...prev.lensItem,
          color: value
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const onLensMaterialChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        lensItem: {
          ...prev.lensItem,
          material: value
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const onNameChanged = ({ value }) => {
    setsItem(prev => {
      return {
        ...prev,
        name: value,
        preview: getPreview({ ...prev, name: value })
      };
    });
  }

  const onFrameTypeChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        frameItem: {
          ...prev.frameItem,
          frameType: value
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const onScleralTypeChanged = ({ value }) => {
    setsItem(prev => {
      let r = {
        ...prev,
        scleralItem: {
          ...prev.scleralItem,
          type: value
        }
      };
      return { ...r, preview: getPreview(r) };
    });
  }

  const IsLens = () => item.typeId == tipoArticulos.LentesOftalmicos
  const IsContactLens = () => item.typeId == tipoArticulos.LentesDeContacto
  const IsFrame = () => item.typeId == tipoArticulos.MarcoAro
  const IsMaintenance = () => item.typeId == tipoArticulos.Mantenimiento
  const IsAccesory = () => item.typeId == tipoArticulos.Accesorios
  const IsLentesEsclerales = item.typeId == tipoArticulos.LentesEsclerales



  const getTittle = () => {
    if (IsLens())
      return "Lentes Oftalmicos";
    if (IsContactLens())
      return "Lentes de contacto";
    if (IsFrame())
      return "Marco-Aro";
    if (IsMaintenance())
      return "Servicio";
    if (IsAccesory())
      return "Accesorio";
    if (IsLentesEsclerales)
      return "Lentes Esclerales";
  }

  const getPreview = (it) => {

    let preview = '';

    const catalog = (id) => {
      let v = it.catalogs.find(e => e.id == id)?.value;
      if (v && v != 'Ninguno')
        preview == '' ? (preview = v) : (preview += (' - ' + v));
    }

    if (it.brandId && !IsLens())
      catalog(it.brandId);


    if (it.modelId)
      catalog(it.modelId);

    //Lentes Oftalmicos
    if (it?.lensItem?.type)
      catalog(it.lensItem.type);

    if (it?.lensItem?.material)
      catalog(it.lensItem.material);

    if (it?.lensItem?.treatment)
      catalog(it.lensItem.treatment);

    if (it?.lensItem?.color)
      catalog(it.lensItem.color);

    //Lentes de contacto
    if (it?.contactLensItem?.type)
      catalog(it.contactLensItem.type);

    //MArco Aro
    if (it?.frameItem?.frameType)
      catalog(it.frameItem.frameType);

    if (it?.scleralItem?.type)
      catalog(it.scleralItem.type);

    if (IsAccesory() || IsMaintenance())
      return it.name;

    return preview;
  }

  const onProfitPercentChanged = (e) => {
    setsItem(prev => {

      return {
        ...prev,
        profitPercent: e.value,
        areaProductStock: {
          ...prev.areaProductStock,
          price: (prev.areaProductStock.costAvg + e.value * prev.areaProductStock.costAvg).toFixed(2)
        }
      };
    });
  }

  const onCostChanged = (e) => {

    setsItem(prev => {

      return {
        ...prev,
        areaProductStock: {
          ...prev.areaProductStock,
          costAvg: e.value,
          price: (e.value + e.value * prev.profitPercent).toFixed(2)
        }
      };
    });
  }

  const { inputRef } = useBarcode({
    value: `${item.code}`,
    options: {
      height: 20
    }
  });

  return (

    <Popup width={900} height={null} title={`${item.id == 0 ? 'Agregar' : 'Editar'}  ${getTittle()}`} visible={itemDialog.open} onHiding={() => { dispatch(closeDialog()); clearItem(); }}>
      <ScrollView showScrollbar="onScroll">
        <Form formData={item} ref={formRef}>

          <GroupItem cssClass="second-group" colCount={2}>


            {(IsMaintenance() || IsAccesory()) &&
              <SimpleItem dataField="name"
                editorOptions={{
                  disabled: !editable,
                  value: item.name,
                  onValueChanged: onNameChanged
                }} >
                <Label text="Nombre" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={50} message="Maximo 50 caracteres" />
              </SimpleItem>
            }


            {IsContactLens() &&
              <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaLenteContacto), valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                <Label text="Marca" />
              </SimpleItem>
            }


            {IsFrame() &&
              <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaMarcoAro), valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                <Label text="Marca" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>
            }

            {IsAccesory() &&
              <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaAccesorio), valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                <Label text="Marca" />
              </SimpleItem>
            }

            {IsLentesEsclerales &&
              <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaLentesEsclerales), valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                <Label text="Marca" />
              </SimpleItem>
            }



            <SimpleItem dataField="modelId" visible={IsContactLens() || IsFrame() || IsLentesEsclerales} editorType="dxSelectBox"
              editorOptions={{ dataSource: item.catalogs.filter(x => (x.catalog == catalogosConocidos.ModeloLenteOftalmico || x.catalog == catalogosConocidos.ModeloLenteContacto || x.catalog==catalogosConocidos.ModeloMarcoAro || x.catalog == catalogosConocidos.ModeloLentesEsclerales) && x.parentId == item.brandId), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onModelChanged }}>
              <Label text="Modelo" />
              {IsFrame() && <RequiredRule message="Este campo es requerido" />}
            </SimpleItem>

            {(IsMaintenance() || IsAccesory() || IsLentesEsclerales) &&
              <SimpleItem dataField="description" colSpan={2} editorType="dxTextArea" editorOptions={{ height: 50, value: item.description }} visible={!IsContactLens() && !IsLens()}>
                <Label text={IsLentesEsclerales ? "Etiqueta" : "Descripción"} />
                <StringLengthRule max={500} message="Maximo 500 caracteres" />
              </SimpleItem>
            }

          </GroupItem>



          {/* Propiedades Lentes */}
          {IsLens() && item.lensItem != null &&
            <GroupItem cssClass="second-group" colCount={2} visible={IsLens()} caption="Propiedades">
              <SimpleItem dataField="lensItem.type" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoLente), valueExpr: "id", displayExpr: "value", onValueChanged: onLensTypeChanged, defaultValue: null }}>
                <Label text="Tipo de lente" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>
              <SimpleItem dataField="lensItem.treatment" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.Tratamiento), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onLensTreatmentChanged }}>
                <Label text="Tratamiento" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>
              <SimpleItem dataField="lensItem.material" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.Material), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onLensMaterialChanged }}>
                <Label text="Material" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>

              <SimpleItem dataField="lensItem.color" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.Color && item.lensItem.treatment == catalogoValores.Tratamiento.Color), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onLensColorChanged }} visible={item.lensItem.treatment == catalogoValores.Tratamiento.Color}>
                <Label text="Color" />
                {IsLens() && item.lensItem.treatment == catalogoValores.Tratamiento.Color &&
                  <RequiredRule message="Este campo es requerido" />
                }
              </SimpleItem>

            </GroupItem>
          }

          {/* Propiedades Lentes de contacto */}
          {IsContactLens() && item.contactLensItem != null &&
            <GroupItem cssClass="second-group" colCount={3} visible={IsContactLens()} caption="Propiedades">
              <SimpleItem dataField="contactLensItem.type" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoLenteContacto), valueExpr: "id", displayExpr: "value", defaultValue: null }}>
                <Label text="Tipo" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>


              <SimpleItem dataField="contactLensItem.diameter" >
                <Label text="Diametro" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={10} message="Maximo 10 caracteres" />
              </SimpleItem>

              <SimpleItem dataField="contactLensItem.baseCurve"  >
                <Label text="Curva Base" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={10} message="Maximo 10 caracteres" />
              </SimpleItem>

              <SimpleItem dataField="contactLensItem.power" >
                <Label text="Potencia" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={10} message="Maximo 10 caracteres" />
              </SimpleItem>

              <SimpleItem dataField="contactLensItem.reChange" editorType="dxSelectBox" editorOptions={{ dataSource: reChanges, valueExpr: "value", displayExpr: "text", defaultValue: null }}>
                <Label text="Recambio" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={50} message="Maximo 10 caracteres" />
              </SimpleItem>
              <EmptyItem />

              <SimpleItem dataField="description" colSpan={3} editorType="dxTextArea" editorOptions={{ height: 50, value: item.description }} >
                <Label text="Descripción" />
                <StringLengthRule max={500} message="Maximo 500 caracteres" />
              </SimpleItem>

            </GroupItem>
          }

          {/* Propiedades Marco-Aro */}
          {IsFrame() && item.frameItem != null &&
            <GroupItem cssClass="second-group" colCount={2} visible={IsFrame()} caption="Propiedades">
              <SimpleItem dataField="frameItem.frameType" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoMarco), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onFrameTypeChanged }}>
                <Label text="Material" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>

              <SimpleItem dataField="frameItem.frameHeight" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.AlturaMarco), valueExpr: "id", displayExpr: "value", defaultValue: null }}>
                <Label text="Altura" />
              </SimpleItem>

              <SimpleItem dataField="frameItem.size" editorType="dxNumberBox">
                <Label text="Tamaño" />
              </SimpleItem>

              <SimpleItem dataField="frameItem.color" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.Color), valueExpr: "id", displayExpr: "value", defaultValue: null }}>
                <Label text="Color" />
              </SimpleItem>

            </GroupItem>
          }

          {/* Propiedades Mantenimiento */}
          {IsMaintenance() && item.maintenanceItem != null &&
            <GroupItem cssClass="second-group" colCount={2} visible={IsMaintenance()} caption="Propiedades">

              <SimpleItem dataField="maintenanceItem.indications" colSpan={2} editorType="dxTextArea" editorOptions={{ height: 50, value: item.maintenanceItem != null ? item.maintenanceItem.indications : null }} >
                <Label text="Indicaciones" />
                <RequiredRule message="Este campo es requerido" />
                <StringLengthRule max={8000} message="Maximo 8000 caracteres" />
              </SimpleItem>

            </GroupItem>

          }

          {/* Propiedades Lentes Esclerales */}
          {IsLentesEsclerales && item.scleralItem != null &&
            <GroupItem cssClass="second-group" colCount={2} visible={IsLentesEsclerales} caption="Propiedades">
              <SimpleItem dataField="scleralItem.type" editorType="dxSelectBox" editorOptions={{ dataSource: item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoLentesEsclerales), valueExpr: "id", displayExpr: "value", defaultValue: null, onValueChanged: onScleralTypeChanged }}>
                <Label text="Tipo" />
                <RequiredRule message="Este campo es requerido" />
              </SimpleItem>
            </GroupItem>
          }

          <GroupItem cssClass="second-group" colCount={2} caption="Costos">
            <SimpleItem dataField="areaProductStock.costAvg" editorType="dxNumberBox" editorOptions={{ onValueChanged: onCostChanged }} visible={!IsMaintenance()} >
              <Label text="Costo" />
              <RequiredRule message="Este campo es requerido" />
            </SimpleItem>

            <SimpleItem dataField="profitPercent" editorType="dxNumberBox" editorOptions={{ step: 0.01, format: "#0%", onValueChanged: onProfitPercentChanged }} visible={!IsMaintenance()}>
              <Label text="Porcentaje de ganancia" />
              <RequiredRule message="Este campo es requerido" />
            </SimpleItem>

            <SimpleItem dataField="areaProductStock.price" editorType="dxNumberBox" editorOptions={{ readOnly: !IsMaintenance() }}>
              <Label text="Precio Vta" />
            </SimpleItem>
            <SimpleItem dataField="minStock" editorType="dxNumberBox">
              <Label text="Stock Minimo" />
            </SimpleItem>
          </GroupItem>

        </Form>

        <div>
          <hr />
          <p>Previsualización: <strong>{item.preview} </strong></p>
        </div>



        <br />
        <div>
          <svg ref={inputRef} height={100} />
        </div>
        <div className='footer-dialog'>        
          <Button
            disabled={saving}
            width={180}
            text={'Imprimi código'}
            type="normal"
            icon='print'
            onClick={() => {

              const report =  urlReport();
              report.print(report.itemsCodeBar(item.id));

            }}
          />
          <Button
            disabled={saving}
            width={180}
            text={saving ? 'Guardando...' : 'Guardar'}
            type="default"
            icon='save'
            onClick={guardarItem}
          />
        </div>
        <br />

      </ScrollView>
    </Popup >

  );
};


AddItemDialog.propTypes = {

};


export default AddItemDialog;
